import { Avatar, Box, Button, Chip, Divider, Stack, Typography, useTheme } from '@mui/material';
import DrawerComponent from '../../components/Drawer';
import { useTranslation } from 'react-i18next';
import { ArrowRightSIcon, EmailIcon, iconFontSize, PhoneIcon } from '../../components/IconComponent';
import { GetIconColor } from '../../theme/main_style';
import { cache } from '../../utils/cache';
import { getFirstLetter, replaceParamTranslation } from '../../utils/util';
import version_info from '../../version.json';
import { getData } from '../../utils/common';
import Countries from '../../Countries';


export default function SettingsView(props) {
    const { palette, breakpoints } = useTheme();    
    const { t } = useTranslation();
    const { menuItems, profileImage, unreadNotificationNumber, showSecurity, isMobilePassSupported, isCommunityWorkspace, communityRelation, isGuest } = props;

    let contact = cache.getContact();
    var name = contact ? contact.first_name + (contact.last_name ? " " + contact.last_name : "") : ""
    if (contact && contact.type === "COMPANY") {
        name = contact.company_name
    }
    let initalContactName = getData('initial_contact_name')
    

    const renderRoot = () => {
        return (
            <>
            <DrawerComponent isOpen={props.open} onClose={props.onClose} title={t('')} showProcessing={props.showProcessing} message={props.message} headerPosition='relative' width='100%' height={20}>
               {renderContent()}
            </DrawerComponent>
            </>
        )
    }

    const renderContent = () => {
        let hasLogout = isGuest ? true : false;
        let phoneNumber = null;

        if(contact && contact.phone && contact.phone.country_code){
            let country_code = contact && contact.phone && contact.phone.country_code ? contact.phone.country_code : 'CYP';
            let countryExist = Countries.filter(x => x.value === country_code);
            let country = (countryExist && countryExist.length > 0) ? countryExist[0] : null;
            phoneNumber = contact && contact.phone && contact.phone.number ? "+ (" + country.phone_code + ") " + contact.phone.number : null;
        }

        return (
            <Box px={2}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    spacing={1}
                    sx={{ mb: 2, cursor: isGuest ? 'default' : 'pointer' }}
                    onClick={() => !isGuest && props.onViewProfile()}
                >
                    <Stack direction="row" alignItems="center" spacing={2}>
                        <Box
                            backgroundColor={palette.primary.main}
                            display="flex"
                            alignContent="center"
                            justifyContent="center"
                            borderRadius="50%"
                            border={'1px solid ' + palette.border.main}
                            alignItems="center"
                            sx={{
                                width: 60,
                                height: 60,
                                [breakpoints.down('md')]: {
                                width: 40,
                                height: 40,
                                },
                            }}
                        >
                            {!profileImage ? 
                                <Typography component="span" padding={0.5} fontSize="0.85rem" color={palette.common.white}>{getFirstLetter(name).toUpperCase()}</Typography>
                                : 
                                <Avatar sx={{ width: '100%', height: '100%' }} src={profileImage} />
                            }
                        </Box>
                        <Box>
                            <Stack flex={1}>
                                <Stack direction={'row'} spacing={1}>
                                    <Stack flex={1} direction='row' spacing={1} alignItems='center'>
                                        <Typography variant='h6'>{isCommunityWorkspace ? initalContactName : name}</Typography>
                                    </Stack>
                                </Stack>
                                <Stack direction={'row'} alignItems='center' spacing={1} mb={0.5}>
                                    {isCommunityWorkspace && <Chip label={name} sx={{ borderRadius: 2, marginRight: 1 }} variant='outlined' color='primary' size='small' />}
                                    {isCommunityWorkspace && communityRelation && <Chip sx={{ borderRadius: 2, }} size='small' label={t(communityRelation) ? t(communityRelation) : communityRelation} />}
                                </Stack>
                                {phoneNumber && 
                                    <Stack direction={'row'} alignItems='center' spacing={1} mb={0.5}>
                                        <PhoneIcon size={iconFontSize.xxxs} color={GetIconColor().default}/>
                                        <Typography variant="subtitle2" color="textSecondary">{phoneNumber}</Typography>
                                    </Stack>
                                } 
                                {contact && contact.email && 
                                    <Stack direction={'row'} alignItems='center' spacing={1} mb={0.5}>
                                        <EmailIcon size={iconFontSize.xxxs} color={GetIconColor().default}/>
                                        <Typography variant="subtitle2" color="textSecondary">{contact.email}</Typography>
                                </Stack>}
                            </Stack>
                        </Box>
                    </Stack>

                    {!isGuest && <ArrowRightSIcon size={iconFontSize.xs} color={GetIconColor().primary} />}
                </Stack>
        
              <Divider />
        
                {menuItems.map((section, idx) => (
                    <Box key={idx} sx={{ mt: 3 }}>
                        <Typography variant="subtitle2" color="textSecondary" sx={{ mb: 1 }}>{section.title}</Typography>
                        <Stack spacing={1}>
                            {section.items.map((item, i) => {
                                let Icon = item.icon
                                if(item.id==='security' && !showSecurity)
                                    return null;
                                if(item.id==='mobile_pass_card' && !isMobilePassSupported)
                                    return null;
                                if(item.id==='logout'){
                                    hasLogout = true;
                                    return null;
                                }
                                return(
                                <Box
                                    key={i}
                                    sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", 
                                        px: 1, py: 1.2, borderRadius: 2, 
                                        '&:hover': { bgcolor: 'action.hover' }, 
                                        opacity: item.enable ? 1 : 0.5,
                                        cursor: item.enable ? 'pointer' : 'default',}}
                                    onClick={(event) => item.enable && props.onClickMenu(item, event, 'menu_profile')} 
                                    >
                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <Box sx={{ mr: 2 }}>  
                                        <Icon color={palette.primary.main}
                                            size={iconFontSize.xxs}
                                        /></Box>
                                    <Typography variant='subtitle2'>{item.id === 'logout_community' ? 
                                        replaceParamTranslation(t('logout_community'), [initalContactName]) : t(item.text)}
                                    </Typography>
                                    {item.id === 'notifications' && unreadNotificationNumber > 0 && 
                                        <Box display={'flex'} alignItems='center' justifyContent='center' px={0.5} maxWidth={100} sx={{ml:2}} backgroundColor={palette.error.main} borderRadius={20}>
                                            <Typography variant='subtitle2' color={palette.common.white}>{unreadNotificationNumber}</Typography>
                                        </Box>
                                    }
                                    {/* {item.id === 'learn' && 
                                        <Chip size='small' variant='customOutlined' sx={{ background: palette.custom2.main, border: `1px solid ${palette.border.main}`, padding: 0, ml:2 }} label={"Coming Soon!"} />
                                    } */}
                                </Box>
                                {/* {item.id !== 'learn' && */}
                                    <ArrowRightSIcon size={iconFontSize.xs} color={GetIconColor().primary} />
                                {/* } */}
                            </Box>
                            )})}
                        </Stack>
                    </Box>
                ))}

                {hasLogout &&
                <Box sx={{ mt: 4 }}>
                    <Button variant="outlined" fullWidth sx={{ borderRadius: 3 }} onClick={() => props.onLogout()}>{t('logout')}</Button>
                </Box>}

                {version_info && version_info.release_version && 
                    <Typography textAlign={'center'} variant="subtitle2" sx={{mt:4}}>{t("version")}{t(" ")}{version_info.release_version}</Typography>
                }

                <Button variant="text" fullWidth sx={{mt:0}} onClick={() => props.onSeeMoreFormalities()}>{t('read_more')}</Button>
            </Box>
        );
    }

    return (
        <>
            {renderRoot()}
        </>
    )
}
